import * as React from 'react';

const SvgStatusFilterFill = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", d: "M9 11.51v10.21l6-3.43v-6.78L22.14 3H1.86L9 11.51Z" })
);

export { SvgStatusFilterFill as default };
//# sourceMappingURL=StatusFilterFill.es.js.map
